/* __next_internal_client_entry_do_not_use__ BannerPicture auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isManuallyCroppedImage } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import React from "react";
import { PageLoadEvent } from "@faire/retailer/services/performance/const";
import { PerformanceMarker } from "@faire/retailer/services/performance/PerformanceMarker";
import { buildBannerImageSrcSet } from "@faire/retailer-visitor-shared/views/brand/BrandHeader/buildBannerImageSrcSet";
var handleBannerPictureLoaded = function() {
    return PerformanceMarker.get().mark(PageLoadEvent.firstMeaningfulPaint);
};
export var BannerPicture = function(param) {
    var brandImage = param.brandImage, removeBackgroundColor = param.removeBackgroundColor;
    var isSSR = useIsSSR();
    if (!brandImage || !brandImage.url) {
        return null;
    }
    var _buildBannerImageSrcSet = buildBannerImageSrcSet(brandImage, isSSR), srcset = _buildBannerImageSrcSet.srcset, sizes = _buildBannerImageSrcSet.sizes, src = _buildBannerImageSrcSet.src;
    var isManuallyCropped = isManuallyCroppedImage(brandImage);
    return /*#__PURE__*/ _jsxs("picture", {
        onLoad: handleBannerPictureLoaded,
        className: "w-full brightness-95" + "h-[120px] md:h-[190px] lg:h-[240px]" + (removeBackgroundColor ? "bg-core-border-muted" : ""),
        children: [
            /*#__PURE__*/ _jsx("source", {
                srcSet: srcset,
                sizes: sizes
            }),
            /*#__PURE__*/ _jsx("img", {
                "data-faire-image-id": brandImage.token,
                src: src,
                alt: brandImage.alt_text,
                className: "h-full w-full object-cover" + (isManuallyCropped ? " object-center" : " object-right")
            })
        ]
    });
};
